<div style="padding: 20px;">
  <mat-spinner class="mat-mdc-spinner"></mat-spinner>
  @if (Message !== '') {
    <h3 style="padding-top: 15px">{{Message}}</h3>
  }
</div>
